import React from 'react'
import {BoxProps, useMultiStyleConfig, Text, VStack} from '@chakra-ui/react'
import {useIntl} from 'react-intl'

interface FindInBoutiqueTitleProps {
    selectSize?: boolean
}

/**
 * @name FindInBoutiqueTitle
 *
 * @component
 *
 * @description
 * Renders the title of the product size selector drawer.
 *
 * @returns {React.FC} - The rendered title component.
 */
const FindInBoutiqueTitle: React.FC<FindInBoutiqueTitleProps> = ({selectSize = false}: FindInBoutiqueTitleProps) => {
    const {formatMessage} = useIntl()
    const styles = useMultiStyleConfig('ProductFindInBoutique', {}) as Record<string, BoxProps>

    const DRAWER_TITLE = formatMessage({id: 'label.find.in.boutique', defaultMessage: 'FIND IN BOUTIQUE'})?.toLowerCase()
    const DRAWER_SUBTITLE = formatMessage({id: 'label.requestsize.title', defaultMessage: 'Select your size'})?.toLowerCase()

    return (
        <VStack {...styles.drawerHeaderWrapper}>
            <Text {...styles.drawerTitle} as={'h2'}>
                {DRAWER_TITLE}
            </Text>

            {selectSize && (
                <Text {...styles.drawerSubtitle} as={'h2'}>
                    {DRAWER_SUBTITLE}
                </Text>
            )}
        </VStack>
    )
}

export default FindInBoutiqueTitle
